<template lang="pug">
    section#extra
        .wrapper
            h2 ALÉM DE TUDO QUE VOCÊ JÁ TEM POR AQUI!
            ul
                li
                    h3 FAEL PERTO DE VOCÊ
                    p
                        |Mais de 400 unidades em todo Brasil, com estrutura e atendimento presencial para 
                        |receber os alunos FAEL em suas atividades, ou sempre que precisarem do apoio do Polo.
                    button(@click="$refs.aside ? $refs.aside.abrirAside(null, 0) : false") saiba mais
                //- li
                    h3 MATERIAL DIDÁTICO INCLUSO
                    p
                        |Acesso aos materiais didáticos nas versões impressas e/ou digitais dos cursos 
                        |de Graduação FAEL, que complementam os conteúdos das videoaulas, sem pagar nada a mais por isso!
                li
                    h3 LIÇÕES DE LIDERANÇA
                    p
                        |Conteúdo com dicas e informações do mercado para a transformação de alunos 
                        |em profissionais bem-sucedidos. Preparamos videoaulas exclusivas apresentando 
                        |o curso, a profissão, e o melhor, como o aluno deve ser na vida profissional! Técnicas 
                        |fundamentais para trabalhar em equipe e ser um profissional diferenciado.
                    button(@click="$refs.aside ? $refs.aside.abrirAside(null, 1) : false") saiba mais
        Aside(ref="aside" :conteudo="extras")
</template>

<script>
import Aside from '@components/Aside/Aside.vue'

export default {
    name: "extra",
    components: {
        Aside,
    },
    data() {
        return {
            extras:[ 
                {
                    titulo: 'FAEL PERTO DE VOCÊ:',
                    texto: '<strong>Você sabe o que é um Polo?</strong><br>Polo de educação a distância, ou polo de apoio presencial, é uma unidade local da FAEL, devidamente credenciada pelo MEC, para o desenvolvimento de atividades pedagógicas e administrativas relativas aos cursos e programas ofertados pela faculdade.<br>Nos nossos polos, o aluno pode receber apoio de um assistente acadêmico, além de contar com toda a infraestrutura local disponível para suporte ao processo de aprendizagem como, por exemplo, laboratórios de informáticas e laboratórios específicos, computadores, salas de estudos, livros, salas de aula, entre outros.<br>No polo, além das atividades pedagógicas obrigatórias, são oportunizadas atividades que promovem interação e integração dos alunos, trazendo ao aluno uma conexão entre a disciplina e conteúdos multidisciplinares.',
                },
                {
                    titulo: 'LIÇÕES DE LIDERANÇA:',
                    texto: `Dados Técnicos<br>Disciplinas: 3<br>Investimento: 100% gratuito. Exclusivo para alunos FAEL.<br><br>O programa: Pacote Profissional<br>A FAEL, em compromisso com a aprendizagem, desenvolveu conteúdos exclusivos e extra curriculares. Mas, sua preocupação foi além, criou um pacote profissional com o propósito de compartilhar orientações para aumentar a capacitação e qualificação do aluno.<br>Nosso objetivo é disponibilizar uma ferramenta especial com conteúdo direcionado ao universo do trabalho.<br><br>Professora Convidada:<br>Daviane Chemim, é nossa professora convidada para Lições de Liderança, onde aborda dicas para trabalhar com equipe coesa, e para colaboradores, gestores e empreendedores nas áreas de gestão e educação.<br><br>Currículo:<br>Daviane Chemin - Psicóloga por formação com certificação em Cultura e Inovação pelo Institut Européen de Stratégies Créatives et d'Innovation – França, Fundadora e Executiva da Dchemin Resultados Humanos, Daviane já foi executiva em diversas empresas multinacionais, além de ter atuado como Presidente da ABRH – Paraná e Vice-Presidente da ABRH Brasil.<br>Especialista nos temas “Educação na aprendizagem transformadora”, “Liderança”, “Cultura Organizacional”, “Inovação” entre outros.`,
                },
            ]
        }
    },
}
</script>

<style lang="stylus" scoped src="./Extra.styl"></style>